import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import AccountStatusEditor from './editor';

@modal(
  {
    className: 'partner-register-city-editor-modal',
  },
  true,
)
class AccountStatusEditorContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { editParams } = this.props;

    return (
      <div className="partner-register-city-editor">
        <div className="partner-register-city-editor__header" style={{ paddingBottom: '24px' }}>
          Edit Partner Account Status
          {/* {t(`cms.referral.partner.detail.editor.register_city.title`)} */}
          <CloseOutlined
            className="partner-register-city-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <AccountStatusEditor
          status={editParams.status}
          partnerId={editParams.partnerId}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

AccountStatusEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  editParams: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

AccountStatusEditorContainer.defaultProps = {
  t: () => {},
  editParams: {},
  handleCloseModal: () => {},
};

export default AccountStatusEditorContainer;
